import React from 'react';
import { FiX, FiSmartphone, FiHash, FiCpu, FiCalendar, FiBattery, FiPackage } from 'react-icons/fi';

const DispositivoDetallesModal = ({ dispositivo, isOpen, onClose }) => {
  if (!isOpen || !dispositivo) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-blue-100 rounded-lg">
              <FiSmartphone className="text-blue-600 text-xl" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                {dispositivo.codigo}
              </h2>
              <p className="text-sm text-gray-500">
                Información del dispositivo
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <FiX className="text-xl" />
          </button>
        </div>

        {/* Contenido */}
        <div className="p-6 space-y-6">
          {/* Información Básica */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Columna Izquierda */}
            <div className="space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                  <FiHash className="mr-2 text-blue-500" />
                  Información del Dispositivo
                </h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-xs font-medium text-gray-500">Código</label>
                    <p className="text-sm text-gray-900 font-mono">{dispositivo.codigo}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500">Marca</label>
                    <p className="text-sm text-gray-900">{dispositivo.marca}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500">Modelo</label>
                    <p className="text-sm text-gray-900">{dispositivo.modelo}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500">Versión Android</label>
                    <p className="text-sm text-gray-900">Android {dispositivo.android_version}</p>
                  </div>
                  {dispositivo.app_version && (
                    <div>
                      <label className="text-xs font-medium text-gray-500">Versión de App MDM</label>
                      <p className="text-sm text-gray-900">{dispositivo.app_version}</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                  <FiCpu className="mr-2 text-green-500" />
                  Identificadores
                </h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-xs font-medium text-gray-500">IMEI</label>
                    <p className="text-sm text-gray-900 font-mono">{dispositivo.imei}</p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500">Serial</label>
                    <p className="text-sm text-gray-900 font-mono">{dispositivo.serial}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Columna Derecha */}
            <div className="space-y-4">


              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                  <FiCalendar className="mr-2 text-orange-500" />
                  Fechas
                </h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-xs font-medium text-gray-500">Fecha de Registro</label>
                    <p className="text-sm text-gray-900">
                      {dispositivo.fecha_registro 
                        ? new Date(dispositivo.fecha_registro).toLocaleString('es-ES')
                        : 'No disponible'
                      }
                    </p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500">Última Actualización</label>
                    <p className="text-sm text-gray-900">
                      {dispositivo.ultima_actualizacion 
                        ? new Date(dispositivo.ultima_actualizacion).toLocaleString('es-ES')
                        : 'Nunca'
                      }
                    </p>
                  </div>
                  <div>
                    <label className="text-xs font-medium text-gray-500">Token Generado</label>
                    <p className="text-sm text-gray-900">
                      {dispositivo.token_generated_at 
                        ? new Date(dispositivo.token_generated_at).toLocaleString('es-ES')
                        : 'No disponible'
                      }
                    </p>
                  </div>
                </div>
              </div>

              {dispositivo.bateria !== null && dispositivo.bateria !== undefined && (
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                    <FiBattery className="mr-2 text-yellow-500" />
                    Batería
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-xs font-medium text-gray-500">Nivel de Batería</span>
                        <span className={`text-sm font-semibold ${
                          dispositivo.bateria >= 50 
                            ? 'text-green-600' 
                            : dispositivo.bateria >= 20 
                            ? 'text-yellow-600' 
                            : 'text-red-600'
                        }`}>
                          {dispositivo.bateria}%
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div 
                          className={`h-2.5 rounded-full ${
                            dispositivo.bateria >= 50 
                              ? 'bg-green-500' 
                              : dispositivo.bateria >= 20 
                              ? 'bg-yellow-500' 
                              : 'bg-red-500'
                          }`}
                          style={{ width: `${dispositivo.bateria}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                  <FiSmartphone className="mr-2 text-blue-500" />
                  Estado del Dispositivo
                </h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-xs font-medium text-gray-500">Modo Kiosk:</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      dispositivo.estado_kiosk === 'locked' 
                        ? 'bg-red-100 text-red-800' 
                        : 'bg-green-100 text-green-800'
                    }`}>
                      {dispositivo.estado_kiosk === 'locked' ? 'Bloqueado' : 'Desbloqueado'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-xs font-medium text-gray-500">Orígenes Desconocidos:</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      dispositivo.estado_ori === 'enabled' 
                        ? 'bg-orange-100 text-orange-800' 
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {dispositivo.estado_ori === 'enabled' ? 'Activos' : 'Inactivos'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-xs font-medium text-gray-500">Modo Desarrollador:</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      dispositivo.estado_dev === 'enabled' 
                        ? 'bg-yellow-100 text-yellow-800' 
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {dispositivo.estado_dev === 'enabled' ? 'Activo' : 'Inactivo'}
                    </span>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default DispositivoDetallesModal;
